import { ICustomerPortalTheme } from "@smartrr/shared/entities/CustomerPortalTheme";

import { typedCustomerFrontendApi } from "@customer-app/shared/typedCustomerFrontendApi";
import { customerAsyncDispatch } from "@customer-app/state/customerAsyncDispatch";
import { CustomerAction, CustomerThunkAction } from "@customer-app/state/typedCustomerRedux";

export const loadTheme =
  (): CustomerThunkAction<"LOADING_THEME" | "LOADING_THEME_ERROR" | "LOADED_THEME"> => dispatch =>
    customerAsyncDispatch(
      typedCustomerFrontendApi.getReq("/customer-portal-theme"),
      () =>
        dispatch({
          type: "LOADING_THEME",
          payload: undefined,
        }),
      failure =>
        dispatch({
          type: "LOADING_THEME_ERROR",
          payload: {
            errorMessage: failure.message,
          },
        }),
      resBody =>
        dispatch({
          type: "LOADED_THEME",
          payload: {
            theme: resBody,
          },
        })
    );

export const setTheme = (theme: ICustomerPortalTheme): CustomerAction<"LOADED_THEME"> => {
  return {
    payload: {
      theme,
    },
    type: "LOADED_THEME",
  };
};
